<template>
  <row :gutter="16">
    <i-col :span="contractPage ? '8' : '12'">
      <div class="ms-text">
        Сумма заявленных требований от Компании
      </div>
      <alert>{{
        getFormattedCosts(
          contractPage ? stats.from_company_law_cases_value : stats.from_company,
          false,
          withVat
        )
      }}</alert>
    </i-col>
    <i-col :span="contractPage ? '8' : '12'">
      <div class="ms-text">
        Сумма заявленных требований к Компании
      </div>
      <alert type="error">
        {{
          getFormattedCosts(
            contractPage ? stats.on_company_law_cases_value : stats.on_company,
            false,
            withVat
          )
        }}
      </alert>
    </i-col>
  </row>
</template>

<script>
import { getFormattedCosts } from '@/utils'

export default {
  props: ['stats', 'contract-page'],
  computed: {
    withVat () {
      return this.$store.state.contracts.current.with_vat
    }
  },
  methods: {
    getFormattedCosts
  }
}
</script>

<style>
</style>
